import { usePostavke } from "@/lib/postavke";

export function PrijelaznoRazdoblje() {
  const { prijelazno, error } = usePostavke();
  if (error) return <p role="alert">Postavke osposobljenosti nisu dostupne. {error}</p>;
  if (!prijelazno) return null;
  return <p role="status" className="rounded-lg border border-amber-400 bg-amber-50 p-3 text-amber-950">
    Prijelazno razdoblje: upozorenja o osposobljenosti se prikazuju, ali ne blokiraju raspored ni unos sati.
  </p>;
}
